import { initializeApp, getApps } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'
import { getAnalytics, isSupported, logEvent, type Analytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId:     import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// App Check — INERT unless VITE_APPCHECK_SITE_KEY is set (see rationale
// in app/customer/src/lib/firebase.ts). Wiring the supplier portal too
// so platform-wide enforcement won't later lock out nurseries.
const appCheckSiteKey = import.meta.env.VITE_APPCHECK_SITE_KEY as string | undefined
if (appCheckSiteKey && typeof window !== 'undefined') {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  } catch (err) {
    console.warn('[appcheck] init skipped', err)
  }
}

export default app
export const auth           = getAuth(app)
export const db             = getFirestore(app)
export const storage        = getStorage(app)
export const functions      = getFunctions(app, 'asia-south1')
export const googleProvider = new GoogleAuthProvider()

// Firebase Analytics — initialized lazily.
let analytics: Analytics | null = null
isSupported().then(supported => {
  if (supported) analytics = getAnalytics(app)
}).catch(() => { /* analytics not available; no-op */ })

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (analytics) logEvent(analytics, name as any, params as any)
}
